const axios = require('axios');
const qs = require('qs');

function _endsWith(str, char) {
	return str.slice(-1) === char;
}

function _beginsWith(str, char) {
	return str.charAt(0) === char;
}

function _fixSlashes(path) {
	let operand = path;
	operand = _endsWith(operand, '/') ? operand.substr(0, operand.length - 1) : operand;
	return _beginsWith(operand, '/') ? operand : `/${operand}`;
}

class RequestBuilder {
	constructor(baseUrl) {
		// properties
		this.url = _endsWith(baseUrl, '/') ? baseUrl.substr(0, baseUrl.length - 1) : baseUrl;
		this.method = 'get';
		this.queryParams = {};
		this.data = {};
		this.timeout = 20000;
		this.responseType = 'json';
		this.headers = {};
		this.maxRedirects = 5; // this is the default value for axios
		this.transformResponse = [];
	}

	withExecuteOverride(override) {
		this.executeOverride = override;
		return this;
	}

	withPath(...args) {
		let i = 0;
		for (i; i < args.length; i += 1) {
			this.url = `${this.url}${_fixSlashes(args[i])}`;
		}
		return this;
	}

	withMethod(method) {
		this.method = method;
		return this;
	}

	withHeaders(headers) {
		this.headers = headers;
		return this;
	}

	withQueryParam(key, value) {
		if (value || value === false) {
			this.queryParams[key] = value;
		}
		return this;
	}

	withData(data) {
		this.data = data;
		return this;
	}

	withMaxRedirects(redirects) {
		this.maxRedirects = redirects;
		return this;
	}

	withTransformResponse(callback) {
		this.transformResponse = [callback];
		return this;
	}

	withXDomainCredentials() {
		this.withCredentials = true;
		return this;
	}

	_getDefaultHeaders() {
		return { 'Accept-Language': 'en-CA' };
	}

	_buildRequest() {
		const query = qs.stringify(this.queryParams);
		const url = `${this.url}${query ? `?${query}` : ''}`;
		const headers = Object.assign(this._getDefaultHeaders(), this.headers);

		return {
			url,
			headers,
			timeout: this.timeout,
			method: this.method,
			data: this.data,
			maxRedirects: this.maxRedirects,
			transformResponse: this.transformResponse,
			withCredentials: this.withCredentials,
		};
	}

	execute() {
		const request = this._buildRequest();

		if (typeof this.executeOverride === 'function') {
			return this.executeOverride(request);
		}

		return axios.request(request);
	}
}


module.exports = {
	default: RequestBuilder,
	RequestBuilder,
	_beginsWith,
	_endsWith,
	_fixSlashes,
};
